enum StripePaymentMethod {
  CARD = "card",
  KLARNA = "klarna"
}

export const StripePaymentMethodValues: StripePaymentMethod[] = [StripePaymentMethod.CARD, StripePaymentMethod.KLARNA]

export default StripePaymentMethod
